import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import "./RctoMobile.css";

export default function RcToMobile() {

  const user = JSON.parse(localStorage.getItem("user") || "{}");

  const [rcno, setRcno] = useState("");
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  // ================= FETCH HISTORY =================
  const loadHistory = async () => {
    try {
      const res = await fetch(
        `https://rcfinder.online/api/get_rc_mobile_list.php?user_id=${user.id}`
      );

      const data = await res.json();
      if (data.list) setHistory(data.list);

    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (user?.id) loadHistory();
  }, []);

  // ================= SEARCH =================
  const handleSearch = async () => {

    if (!rcno) {
      Swal.fire("Enter RC Number");
      return;
    }

    if (!user?.id) {
      Swal.fire("Session Expired", "Login Again", "warning");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch("https://rcfinder.online/api/rc_to_mobile.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          user_id: user.id,
          rcno
        })
      });

      const data = await res.json();

      if (data.status === "wallet_low") {
        Swal.fire("Wallet Low", "Please Recharge", "warning");
      }

      else if (data.status === "failed") {
        Swal.fire("Not Found ❌", data.message || "No Data", "error");
      }

      else if (data.status === "success") {

        let title = data.duplicate
          ? "Already Searched 📄"
          : "Mobile Found 🎉";

        await Swal.fire({
          icon: "success",
          title: title,
          html: `
            <b>RC:</b> ${data.rcno}<br>
            <b>Owner Name:</b> ${data.full_name}<br>
            <b>Father Name:</b> ${data.relation_name}<br>
            <b>Mobile:</b> ${data.mobile}
          `,
          confirmButtonText: "OK"
        });

        setRcno("");
        loadHistory();
      }

    } catch (e) {
      console.log(e);
      Swal.fire("Server Error", "", "error");
    }

    setLoading(false);
  };


  return (
    <div className="rcmob-wrapper">

      <h2 className="rcmob-title">RC → Mobile Finder</h2>
      <p className="rcmob-price">💰 ₹100 per successful result</p>

      <div className="rcmob-box">

        <input
          type="text"
          placeholder="Enter RC Number (DL01AB1234)"
          value={rcno}
          onChange={e => setRcno(e.target.value.toUpperCase().replace(/\s/g, ""))}
        />

        <button onClick={handleSearch} disabled={loading}>
          {loading ? "Please wait..." : "Get Mobile Number (₹100)"}
        </button>

      </div>

      {/* ================= HISTORY ================= */}
      <div className="rcmob-history">

        <h3>📄 Search History</h3>

        {history.length === 0 ? (
          <p className="empty">No history yet</p>
        ) : (
          <table>
            <thead>
              <tr>
                <th>RC Number</th>
                <th>Mobile</th>
                <th>Owner Name</th>
                <th>Father Name</th>
                <th>Date & Time</th>
                <th>Charge</th>
              </tr>
            </thead>

            <tbody>
              {history.map((h, i) => (
                <tr key={i}>
                  <td>{h.rcno}</td>
                  <td>{h.mobile}</td>
                  <td>{h.full_name}</td>
                  <td>{h.relation_name}</td>
                  <td>{h.created_at}</td>
                  <td style={{ color: "green", fontWeight: "bold" }}>
                    ₹100
                  </td>
                </tr>
              ))}
            </tbody>

          </table>
        )}

      </div>

    </div>
  );
}